export default {
	api: {
		baseUrl: `https://hxp-api.abundant.health/api/v1/`,
		scApiKey: '%7B614287E4-6C10-41DA-B2D8-10A9392302DC%7D',
	},
	axios: {
		baseUrl: {
			mock: '',
			localSitecore: '',
			testSitecore: '',
			sitecore: ``,
		},
		contentType: 'application/x-www-form-urlencoded',
	},
	mapCenter: { lat: 40.8519828, lng: -89.5927631 },
	breakpoints: {
		xs: 0,
		sm: 375,
		md: 768,
		lg: 1280,
		xl: 1440,
		xxl: 1680,
	},
	fallbackImages: {
		location:
			'https://osf-p-001.sitecorecontenthub.cloud/api/public/content/placeholder-location-transparent',
		providerFemale:
			'https://hxp.abundant.health/-/media/images/providerdataconnector/providers/provider-fallback-f.png',
		providerMale:
			'https://hxp.abundant.health/-/media/images/providerdataconnector/providers/provider-fallback-m.png',
	},
	/* This will return all focusable items inside the object you pass in. */
	focusable: (obj, excludeNonFocusableAttr) => {
		let nodeList = obj.querySelectorAll(
			'a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]'
		)

		return Array.from(nodeList).filter(elem => {
			return excludeNonFocusableAttr
				? !elem.matches('[tabindex="-1"]') &&
						!elem.matches('[disabled]')
				: elem
		})
	},
	isFrontEndMode: /(localhost|yellow-flower|dxp-frontend)/.test(
		location.hostname
	),
	isLocalSitecore: /(hxp.dev.local)/.test(location.hostname),
	smoothScroll: {
		customEasing: time => {
			/* easeInOut CSS match */
			return 0.5 * (Math.sin((time - 0.5) * Math.PI) + 1)
		},
		easing: 'easeInOutCubic',
		speed: 400,
	},
}
